module.exports = __webpack_public_path__ + "img/joseph_lazy.54f152de.png";